@if (outageBannerApplicable(currentPage$ | async)) {
  <nwx-outage-banner
    [outageMessage]="outageMessage"
  ></nwx-outage-banner>
}
@if (headerApplicable(currentPage$ | async)) {
  <nwx-header
    [currentPage]="currentPage$ | async"
  ></nwx-header>
}
@if (compraterHeaderApplicable(currentPage$ | async)) {
  <nwx-comprater-header
  ></nwx-comprater-header>
}
<nwx-toaster></nwx-toaster>
<div id="main-container">
  @if ((currentPage$ | async)?.showNavBar || false) {
    <nwx-nav-sidebar
      [currentPage]="currentPage$ | async"
      [ngClass]="{ 'needs-min-width': !(maxSizeXSmall$ | async) }"
    ></nwx-nav-sidebar>
  }
  <main #main class="nwx-containers">
    <router-outlet></router-outlet>
    <nwx-loading-spinner
      [loading]="(appLoading$ | async) || false"
      [message]="(loadingMessage$ | async) || defaultLoadingMessage"
      [containerMode]="true"
    ></nwx-loading-spinner>
  </main>
</div>
<footer>
  <nwx-footer></nwx-footer>
</footer>
<nwx-loading-spinner
  [loading]="(appLoading$ | async) || false"
  [message]="(loadingMessage$ | async) || defaultLoadingMessage"
  [containerMode]="false"
></nwx-loading-spinner>
@if (showDebugOverlay) {
  <nwx-debug-overlay></nwx-debug-overlay>
}

